import Identificable from '../types/identificable';

export const idsFrom = ( items: Identificable[] ) => items.map( item => item.id );
